<template>
  <v-tabs :v-model="activeTab">
    <v-tabs-slider color="accent"></v-tabs-slider>
    <v-tab @click="getTabContent('Active')">Active</v-tab>
    <v-tab @click="getTabContent('Funded')">Funded</v-tab>
    <v-tab @click="getTabContent('Inactive')">Inactive</v-tab>
    <v-tab-item class="px-0">
      <v-subheader v-if="FunderEnquiries.Active.length === 0">No active enquiries</v-subheader>
      <v-layout class="enquiry-list-container" column v-else>
        <v-flex class="enquiry-list" ref="activeScrollContainer">
          <funder-enquiry-list-tile
            v-for="enquiry in FunderEnquiries.Active"
            :enquiry="enquiry"
            :key="enquiry.id"
          ></funder-enquiry-list-tile>
          <mugen-scroll
            :handler="scrollActivePage"
            scroll-container="activeScrollContainer"
            :threshold="0.7"
            :should-handle="!activeLoading"
            v-if="pagesAvailable('Active')"
          >
            <v-layout align-center justify-center>
              <v-progress-circular size="25" :width="3" color="accent" indeterminate class="py-4"></v-progress-circular>
            </v-layout>
          </mugen-scroll>
        </v-flex>
      </v-layout>
    </v-tab-item>

    <v-tab-item class="px-0">
      <v-subheader v-if="FunderEnquiries.Funded.length === 0">No funded enquiries</v-subheader>
      <v-layout class="enquiry-list-container" column v-else>
        <v-flex class="enquiry-list" ref="fundedScrollContainer">
          <funder-enquiry-list-tile
            v-for="enquiry in FunderEnquiries.Funded"
            :enquiry="enquiry"
            :key="enquiry.id"
          ></funder-enquiry-list-tile>
          <mugen-scroll
            :handler="scrollFundedPage"
            scroll-container="fundedScrollContainer"
            :threshold="0.7"
            :should-handle="!fundedLoading"
            v-if="pagesAvailable('Funded')"
          >
            <v-layout align-center justify-center>
              <v-progress-circular size="25" :width="3" color="accent" indeterminate class="py-4"></v-progress-circular>
            </v-layout>
          </mugen-scroll>
        </v-flex>
      </v-layout>
    </v-tab-item>

    <v-tab-item class="px-0">
      <v-subheader v-if="FunderEnquiries.Inactive.length === 0">No inactive enquiries</v-subheader>
      <v-layout class="enquiry-list-container" column v-else>
        <v-flex class="enquiry-list" ref="inactiveScrollContainer">
          <funder-enquiry-list-tile
            v-for="enquiry in FunderEnquiries.Inactive"
            :enquiry="enquiry"
            :key="enquiry.id"
          ></funder-enquiry-list-tile>
          <mugen-scroll
            :handler="scrollInactivePage"
            scroll-container="inactiveScrollContainer"
            :threshold="0.7"
            :should-handle="!inactiveLoading"
            v-if="pagesAvailable('Inactive')"
          >
            <v-layout align-center justify-center>
              <v-progress-circular size="25" :width="3" color="accent" indeterminate class="py-4"></v-progress-circular>
            </v-layout>
          </mugen-scroll>
        </v-flex>
      </v-layout>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import _ from 'lodash';
import FunderEnquiryListTile from './FunderEnquiryListTile';
import { mapGetters, mapActions } from 'vuex';
import MugenScroll from 'vue-mugen-scroll';

export default {
  components: {
    FunderEnquiryListTile,
    MugenScroll
  },
  name: 'funder-enquiry-list',
  props: [],
  data: () => ({
    showInactive: false,
    activeTab: null,
    tabStatus: {
      Active: {
        selected: false
      },
      Funded: {
        selected: false
      },
      Inactive: {
        selected: false
      }
    }
  }),
  computed: {
    ...mapGetters([
      'FunderEnquiries',
      'EnquiryCurrentPage',
      'EnquiryLastPage',
      'EnquiryTotal',
      'SelectedFunder',
      'SelectedFunderEnquiryTab'
    ]),
    activeLoading() {
      return this.EnquiryTotal.Active === null;
    },
    fundedLoading() {
      return this.EnquiryTotal.Funded === null;
    },
    inactiveLoading() {
      return this.EnquiryTotal.Inactive === null;
    }
  },
  methods: {
    ...mapActions(['getFunderEnquiries', 'setSelectedFunderEnquiryTab']),
    scrollActivePage() {
      this.scrollPage('Active');
    },
    scrollFundedPage() {
      this.scrollPage('Funded');
    },
    scrollInactivePage() {
      this.scrollPage('Inactive');
    },
    scrollPage(enquiryState) {
      if (this.EnquiryCurrentPage[enquiryState] <= this.EnquiryLastPage[enquiryState]) {
        this.getFunderEnquiries({ append: true, enquiryState }).catch(error => {
          console.log(error);
        });
      }
    },
    pagesAvailable: function(enquiryState) {
      return this.EnquiryCurrentPage[enquiryState] <= this.EnquiryLastPage[enquiryState];
    },
    loading(enquiryState) {
      return this.EnquiryTotal[enquiryState] === null;
    },
    getTabContent(enquiryState) {
      _.map(this.tabStatus, function(tabs) {
        tabs.selected = false;
      });
      this.tabStatus[enquiryState].selected = true;
      this.setSelectedFunderEnquiryTab(this.tabStatus);
      if (this.FunderEnquiries[enquiryState].length < 1 || this.SelectedFunderEnquiryTab[enquiryState].stale === true) {
        this.getFunderEnquiries({ append: false, enquiryState });
        const update = {
          [enquiryState]: {
            stale: false
          }
        };
        this.setSelectedFunderEnquiryTab(update);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.enquiry-list-x-container {
  height: calc(100vh - 180px);
  max-height: calc(100vh - 180px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}
.enquiry-list {
  height: calc(100vh - 200px);
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
